import { gql } from '@apollo/client';

export const GET_ANIMALS_WITH_SURGERIES = gql`
  query GetAnimalWithSurgeries(
    $startDate: String
    $endDate: String
    $location: String
  ) {
    getAnimalsWithSurgeries(
      input: { startDate: $startDate, endDate: $endDate, location: $location }
    ) {
      animalSpecies
      animalSex
      animalOwnerStatus
      fieldName
      total
    }
  }
`;
